export const setCurrentPath = (currentPath) => {
    return {
        type : "CURRENT_PATH",
        payload: currentPath
    }
};